import { MAP_STYLES } from '../../domain/map-style';
import { CAMERA_PLATFORMS } from '../../domain/camera-platform';
import { SOCIAL_LAYOUTS } from '../../../../renderer/src/social-presentation';
import { RENDER_PRESETS } from '../../domain/render-preset';
import { MAP_SAMPLE_PRESET, sampleVideoUrl, samplePrepared } from './settings';
import { COVER_MAP_IDS, COVER_FORMATS, coverPreset, coverSampleId } from './cover-variants';

export const SAMPLE_MAPS = MAP_STYLES.filter(style => !style.previewOnly && samplePrepared(`map-${style.id}`));
export const FEATURE_COUNTS = { maps: SAMPLE_MAPS.length, cameras: CAMERA_PLATFORMS.length, layouts: SOCIAL_LAYOUTS.length };
export const MAP_VIDEO_SAMPLES = SAMPLE_MAPS.map(map => ({ id: map.id, label: map.label,
  src: sampleVideoUrl(`map-${map.id}`),
  output: RENDER_PRESETS.find(preset => preset.id === MAP_SAMPLE_PRESET)!,
}));
export const COVER_VIDEO_SAMPLES = COVER_MAP_IDS.map(id => {
  const map = SAMPLE_MAPS.find(map => map.id === id)!;
  return { id, label: map.label, variants: Object.fromEntries(COVER_FORMATS.map(format => [format, {
    src: sampleVideoUrl(coverSampleId(id, format)),
    output: RENDER_PRESETS.find(preset => preset.id === coverPreset(format))!,
  }])) as Record<typeof COVER_FORMATS[number], { src: string; output: typeof RENDER_PRESETS[number] }> };
});
export const VIDEO_SAMPLES = [
  { id: 'feed', preset: 'social-4x5', label: 'Feed', ratio: '4:5',
    platforms: 'More room in Instagram and Social feeds.', map: 'Topo', camera: 'DJI Drone',
    src: sampleVideoUrl('feed') },
  { id: 'landscape', preset: 'landscape-16x9', label: 'Landscape', ratio: '16:9',
    platforms: 'YouTube, websites, and the big screen.', map: 'Structures', camera: 'Night Stalker',
    src: sampleVideoUrl('landscape') },
  { id: 'vertical', preset: 'vertical-9x16', label: 'Vertical', ratio: '9:16',
    platforms: 'Instagram Reels and Stories, TikTok, and those YT Short things.', map: 'Terra', camera: 'Chase',
    src: sampleVideoUrl('vertical') },
].map(sample => ({ ...sample, output: RENDER_PRESETS.find(preset => preset.id === sample.preset)! }));
